import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { QueryDirection } from '@tribeplatform/gql-client/types'

interface MsgEditedParams {
  chatId: string
}

export const useHandleMessageEdited = () => {
  const queryClient = useQueryClient()

  const handleMessageEdited = useCallback(
    (params: MsgEditedParams) => {
      const { chatId } = params
      queryClient.invalidateQueries({
        exact: false,
        predicate: query => {
          return (
            query.queryHash?.includes(QueryDirection.Before) &&
            query.queryHash?.includes(chatId)
          )
        },
      })
      queryClient.invalidateQueries({
        exact: false,
        predicate: query => {
          return (
            query.queryHash?.includes(QueryDirection.After) &&
            query.queryHash?.includes(chatId)
          )
        },
      })
    },
    [queryClient],
  )

  return {
    handleMessageEdited,
  }
}
